import { Table } from '@shared/Table'
import React from 'react'
import { columns as defaultColumns } from '../../../../constants/orderdetailtableinfo.columns'
import { useFetchOrderDetailsMutation } from 'store/reducers/salaryCards/orderDetails.api'
const OrderDetailModalTable = () => {
  const [_, { data: detailInformationList }] = useFetchOrderDetailsMutation({
    fixedCacheKey: 'fetchOrderDetails',
  })
  const columns = defaultColumns()
  return (
    <>
      <Table
        tableKey="orderDetailTable"
        editColumns={columns}
        dataSource={detailInformationList?.employees}
        pagination={false}
        size="small"
        scroll={{ x: 1500, y: 300 }}
      />
    </>
  )
}

export default OrderDetailModalTable
